export enum LangSelectorOrder {
  ALPHABETICAL = 'alphabetical',
  DEFAULT = 'default'
}

export enum LangSelectorKinds {
  TEXT = 'text',
  FLAG = 'flag',
  TEXT_AND_FLAG = 'textAndFlag'
}

export enum LangSelectorTypes {
  WEB = 'web',
  USER_PREFERRED = 'userPreferred'
}

export enum LangSelectorSizes {
  LG = 'large',
  SM = 'small'
}

export enum LangSelectorDirection {
  DOWN = 'down',
  UP = 'up'
}